import { apiFetch } from "../api.js";
import type {
  CreateHsaReceiptInput,
  HsaReceipt,
  HsaReceiptsListResponse,
  UpdateHsaReceiptInput,
} from "./types.js";

/**
 * HSA receipt vault — Phase 5 Session 5. Receipts are partitioned by
 * household_id (not account_id), but the `account_id` query param + the
 * `by_account` GSI surface a per-HSA-account view for the
 * `<HsaReceiptsPanel>` component on the accounts drilldown.
 */
export function listHsaReceipts(opts?: {
  account_id?: string;
}): Promise<HsaReceiptsListResponse> {
  const qs = opts?.account_id ? `?account_id=${opts.account_id}` : "";
  return apiFetch<HsaReceiptsListResponse>(`/v1/hsa-receipts${qs}`);
}

export function getHsaReceipt(
  serviceDate: string,
  receiptId: string,
): Promise<HsaReceipt> {
  return apiFetch<HsaReceipt>(`/v1/hsa-receipts/${serviceDate}/${receiptId}`);
}

export function createHsaReceipt(
  input: CreateHsaReceiptInput,
): Promise<HsaReceipt> {
  return apiFetch<HsaReceipt>("/v1/hsa-receipts", {
    method: "POST",
    body: JSON.stringify(input),
  });
}

export function updateHsaReceipt(
  serviceDate: string,
  receiptId: string,
  input: UpdateHsaReceiptInput,
): Promise<HsaReceipt> {
  return apiFetch<HsaReceipt>(`/v1/hsa-receipts/${serviceDate}/${receiptId}`, {
    method: "PATCH",
    body: JSON.stringify(input),
  });
}

export function deleteHsaReceipt(
  serviceDate: string,
  receiptId: string,
): Promise<void> {
  return apiFetch<void>(`/v1/hsa-receipts/${serviceDate}/${receiptId}`, {
    method: "DELETE",
  });
}
